import { TypedDocumentNode, gql } from '@apollo/client';
import { CSSProperties } from 'react';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';

import { CardPack } from './CardPack';
import { CardPackGroup_cardPackGroup } from './__generated__/index.graphql';

const Root = styled(Vertical).attrs({ gap: 2 })`
  background: linear-gradient(
    to bottom,
    var(--background-color) 0%,
    var(--c-black) 100%
  );
  border-radius: var(--double-unit);
  border: 1px solid var(--c-nd-150);
  padding: var(--double-unit);
`;
const Logo = styled.img`
  width: calc(5 * var(--unit));
  height: calc(5 * var(--unit));
  object-fit: contain;
`;
const PacksWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: var(--double-unit);
`;

type Props = { cardPackGroup: CardPackGroup_cardPackGroup };
export const CardPackGroup = ({ cardPackGroup }: Props) => {
  const { color, pictureUrl, title, cardPacks } = cardPackGroup;
  return (
    <Root style={{ '--background-color': color } as CSSProperties}>
      <Horizontal>
        <Logo src={pictureUrl} alt="" />
        <LabelL bold>{title}</LabelL>
      </Horizontal>
      <PacksWrapper>
        {cardPacks.map(cardPack => {
          return (
            <CardPack
              key={cardPack.slug}
              cardPack={cardPack}
              groupColor={color}
            />
          );
        })}
      </PacksWrapper>
    </Root>
  );
};

CardPackGroup.fragments = {
  cardPackGroup: gql`
    fragment CardPackGroup_cardPackGroup on CardPackGroup {
      id
      color
      pictureUrl
      title
      cardPacks {
        slug
        ...CardPack_cardPack
      }
    }
    ${CardPack.fragments.cardPack}
  ` as TypedDocumentNode<CardPackGroup_cardPackGroup>,
};
